export default {"src":"/login-app/[GIT_HASH]/_next/static/media/dynamic_feed.d7ea4f98.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};